// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Atom_Box = require("./Atom_Box.bs.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Particle_Screen_Ds = require("../particle/Particle_Screen_Ds.bs.js");
var Particle_Spacer_Ds = require("../particle/Particle_Spacer_Ds.bs.js");

function Atom_Row(Props) {
  var accessibility = Props.accessibility;
  var alignItems = Props.alignItems;
  var alignSelf = Props.alignSelf;
  var animation = Props.animation;
  var area = Props.area;
  var autoSize = Props.autoSize;
  var background = Props.background;
  var blockSpaceOpt = Props.blockSpace;
  var border = Props.border;
  var children = Props.children;
  var childRules = Props.childRules;
  var dataAnchor = Props.dataAnchor;
  var deviceRules = Props.deviceRules;
  var display = Props.display;
  var displayOrder = Props.displayOrder;
  var gap = Props.gap;
  var height = Props.height;
  var id = Props.id;
  var identifier = Props.identifier;
  var innerSpace = Props.innerSpace;
  var justifyContent = Props.justifyContent;
  var kind = Props.kind;
  var maxHeight = Props.maxHeight;
  var maxWidth = Props.maxWidth;
  var minHeight = Props.minHeight;
  var onBlur = Props.onBlur;
  var onFocus = Props.onFocus;
  var rules = Props.rules;
  var width = Props.width;
  var wrapOpt = Props.wrap;
  var ref_ = Props.ref_;
  var blockSpace = blockSpaceOpt !== undefined ? Caml_option.valFromOption(blockSpaceOpt) : Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeNone(undefined));
  var wrap = wrapOpt !== undefined ? wrapOpt : /* MultiLine */0;
  var tmp = {
    children: children,
    direction: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "row"),
    spacer: blockSpace,
    wrap: wrap
  };
  if (accessibility !== undefined) {
    tmp.accessibility = Caml_option.valFromOption(accessibility);
  }
  if (alignItems !== undefined) {
    tmp.alignItems = Caml_option.valFromOption(alignItems);
  }
  if (alignSelf !== undefined) {
    tmp.alignSelf = Caml_option.valFromOption(alignSelf);
  }
  if (animation !== undefined) {
    tmp.animation = Caml_option.valFromOption(animation);
  }
  if (area !== undefined) {
    tmp.area = area;
  }
  if (autoSize !== undefined) {
    tmp.autoSize = Caml_option.valFromOption(autoSize);
  }
  if (background !== undefined) {
    tmp.background = Caml_option.valFromOption(background);
  }
  if (border !== undefined) {
    tmp.border = Caml_option.valFromOption(border);
  }
  if (childRules !== undefined) {
    tmp.childRules = Caml_option.valFromOption(childRules);
  }
  if (dataAnchor !== undefined) {
    tmp.dataAnchor = dataAnchor;
  }
  if (deviceRules !== undefined) {
    tmp.deviceRules = Caml_option.valFromOption(deviceRules);
  }
  if (display !== undefined) {
    tmp.display = Caml_option.valFromOption(display);
  }
  if (displayOrder !== undefined) {
    tmp.displayOrder = Caml_option.valFromOption(displayOrder);
  }
  if (gap !== undefined) {
    tmp.gap = Caml_option.valFromOption(gap);
  }
  if (height !== undefined) {
    tmp.height = Caml_option.valFromOption(height);
  }
  if (id !== undefined) {
    tmp.id = id;
  }
  if (identifier !== undefined) {
    tmp.identifier = identifier;
  }
  if (justifyContent !== undefined) {
    tmp.justifyContent = Caml_option.valFromOption(justifyContent);
  }
  if (kind !== undefined) {
    tmp.kind = Caml_option.valFromOption(kind);
  }
  if (maxHeight !== undefined) {
    tmp.maxHeight = Caml_option.valFromOption(maxHeight);
  }
  if (maxWidth !== undefined) {
    tmp.maxWidth = Caml_option.valFromOption(maxWidth);
  }
  if (minHeight !== undefined) {
    tmp.minHeight = Caml_option.valFromOption(minHeight);
  }
  if (onBlur !== undefined) {
    tmp.onBlur = Caml_option.valFromOption(onBlur);
  }
  if (onFocus !== undefined) {
    tmp.onFocus = Caml_option.valFromOption(onFocus);
  }
  if (rules !== undefined) {
    tmp.rules = Caml_option.valFromOption(rules);
  }
  if (width !== undefined) {
    tmp.width = Caml_option.valFromOption(width);
  }
  if (innerSpace !== undefined) {
    tmp.innerSpace = Caml_option.valFromOption(innerSpace);
  }
  if (ref_ !== undefined) {
    tmp.ref_ = Caml_option.valFromOption(ref_);
  }
  return React.createElement(Atom_Box.make, tmp);
}

Atom_Row.displayName = "Row";

var make = Atom_Row;

exports.make = make;
/*  Not a pure module */
